import styled from "styled-components";
import { flexColumn, flexRow } from "./styles";

const FlexEnd = () => `
display: flex;
flex-direction: column;
align-items: flex-end;
`;

export const Container = styled.div`
  ${flexColumn};
  justify-content: flex-start;
  background: linear-gradient(288deg, #402e0b 0%, #584011 102.83%);
  font-family: "Manrope", sans-serif;
  transition: all 0.6s;
  min-height: 100vh;
  .trait-box {
    width: 720px;
  }
  section {
    position: relative;
    z-index: 3;
    ${FlexEnd};
  }
  a {
    text-decoration: none;
    color: #f3f1ef;
  }
  .header {
    font-weight: 800;
    font-size: 30px;
    letter-spacing: -0.02em;
    font-family: "Manrope";
    background: linear-gradient(
      274.25deg,
      #584011 -8.49%,
      rgba(159, 117, 34, 0.8) 103.71%,
      #725317 111.44%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
    text-transform: uppercase;
  }
  .margin-box {
    width: 100%;
    position: sticky;
    top: 5%;
    overflow: hidden;
    padding: 60px 82px;
    z-index: 1;
  }
  .margin-box.scroll {
    // position: relative;
  }
  .t {
    width: 474.25px;
    height: 444.25px;
    left: -10%;
    top: -10%;
    z-index: -1;
    transition: all 1s;
  }
  .t.lean {
    opacity: 0.2;
    transform: translateY(30%);
  }
  .trait {
    height: 428px;
    width: 126px;
    right: 0;
    bottom: 0;
  }
  .trait.vanish {
    opacity: 0.1;
  }
  .t,
  .trait {
    position: absolute;
  }

  .views {
    display: flex;
    gap: 186.29px;
    align-items: flex-start;
    h1,
    h3 {
      color: #cf992e;
    }
    .view-1 {
      ${flexColumn};
      width: fit-content;
      align-self: center;
      gap: 12.75px;
      .logo {
        height: 72px;
        width: 84.21px;
        margin-top: 24px;
        transition: all 0.6s;
      }
      h3 {
        font-weight: 700;
        font-size: 22.5px;
        transition: all 0.4s ease;
      }
    }
    .view-1.animate {
      .logo {
        transform: translateY(-40%);
      }
      h3 {
        opacity: 0;
      }
    }
    .view-1.vanish {
      .logo {
        opacity: 0;
      }
      h3 {
        opacity: 0;
      }
    }

    .view-head {
      ${flexColumn};
      align-items: flex-start;
      transition: all 1s ease;
      h1 {
        font-weight: 800;
        font-size: 95.625px;
      }
      h5 {
        font-weight: 400;
        font-size: 18px;
        color: #fff2d7;
        transform: translateX(24px);
        margin-top: -16px;
        transition: all 1s ease;
      }
    }
    .view-head.animate {
      transform: translateY(60%);
      h5 {
        transform: scale(1.3) translateX(32px);
      }
    }
    .view-head.vanish {
      opacity: 0;
    }
  }
  .list {
    ${flexRow};
    gap: 20px;
    margin-top: 9px;

    .animate:nth-child(2) {
      transform: translateX(150%);
      opacity: 0;
    }
    .animate {
      transform: translateX(-150%);
      opacity: 0;
    }
    .group {
      ${flexColumn};
      align-items: flex-start;
      gap: 15px;
      transition: all 0.6s ease-out;
      .nums {
        ${flexRow};
        justify-content: flex-start;
        h4,
        p {
          ${flexColumn};
          height: 30px;
        }
        h4 {
          font-family: roboto mono;
          font-weight: 700;
          font-size: 12px;
          color: #ffc961;
          width: 45.75px;
        }
        p {
          font-family: roboto;
          font-weight: 500;
          font-size: 9px;
          width: 111px;
          align-items: flex-start;
          text-transform: capitalize;
        }
      }
    }
  }
`;

export const Intro = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: row !important;
  align-items: center !important;
  padding: 0px 25px;
  z-index: 6;
  .text-fill {
    width: 278.62px;
    font-family: "Manrope", sans-serif;
    color: #402e0b;
    opacity: 0;
    transition: all 0.6s;
    ${flexColumn};
    gap: 19.5px;
    h2 {
      font-family: "Manrope", sans-serif;
      font-weight: 600;
      font-size: 30px;
      line-height: 41px;
      letter-spacing: -0.02em;
    }
    p {
      font-size: 11.25px;
      line-height: 15px;
    }
  }
  .text-fill.appear {
    opacity: 1;
  }
  .phone {
    width: 442px;
    height: 595px;
    margin-bottom: 40px;
    transform: translate(30px, 40px);
    z-index: 10;
  }
`;

export const Thinker = styled.section`
  margin-top: 50px;
  padding: 34px 25px;
  font-family: "manrope" !important;
  .think-head {
    height: 58px;
    display: flex;
    flex-direction: column;
    h1,
    h6 {
      font-family: "Manrope", sans-serif;
      transition: all 1s ease;
    }
    h1 {
      
      font-weight: 800;
      font-size: 30px;
      letter-spacing: -0.02em;
      background: linear-gradient(
        274.25deg,
        #584011 -8.49%,
        rgba(159, 117, 34, 0.8) -8.48%,
        #725317 111.44%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      text-transform: uppercase;
    }
    h6 {
      font-weight: 400;
      font-size: 13.5px;
      letter-spacing: 0.02em;
      margin-top: -5px;
      background: linear-gradient(
        274.25deg,
        #584011 -8.49%,
        #cf992e -0.75%,
        #725317 111.44%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      text-transform: uppercase;
     
    }
    
    }
  }
  .think-head.slide {
    h6{
      transform: translateX(18%);
    }
     h6,h1{  
      background: linear-gradient(
      274.25deg,
      #584011 -8.49%,
      #cf992e 103.71%,
      #725317 111.44%
    );

    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
      }
  }
  
`;

export const ThinkBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
  .think-card {
    width: 120.38px;
    height: 168.75px;
    background: #4f433a;
    box-shadow: 0px 0px 5.625px rgba(0, 0, 0, 0.1);
    border-radius: 1.875px;
    padding: 10.5px 6px;
    color: #fff8eb;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 6.75px;
    color: #fff8eb;
    align-items: center;
    img{
      width: 16.88px;
      height: 16.88px;
    }
    h4 {
      font-weight: 600;
      font-size: 13.5px;
    }
    p {
      span {
        font-weight: 600;
      }
      font-size: 9px;
      line-height: 12px;
    }
  }
  .think-card:nth-child(2n) {
    color: #4f433a;
    background: #fff8eb;
`;

export const Story = styled.section`
  padding: 0 25px;
  margin: 150px 0;

  h1 {
    text-align: right;
    margin-bottom: 5px;
  }
  .story-box {
    display: flex;
    justify-content: flex-end;
    gap: 32.65px;
    img {
      width: 274.5px;
      height: 193.12px;
    }
    .story-text {
      p {
        font-weight: 400;
        font-size: 9px;
        line-height: 12px;
        color: #402e0b;
        margin-bottom: 5px;
        width: 168.38px;
      }
    }
  }
`;

export const Analysis = styled.section`
  margin-bottom: 150px;
  table {
    border-collapse: collapse;
    width: 554.25px;
    tr {
      th {
        font-weight: 800;
        font-size: 13.5px;
        text-align: center;
        color: #725317;
        padding: 8.62px;
      }

      td {
        padding: 10px 15px;
        li {
          display: flex;
          flex-direction: column;
          width: 150px;
          height: 30.5px;
          gap: 7.75px;

          ul {
            font-weight: 500;
            font-size: 7.5px;
            line-height: 10px;
          }
        }
      }
      td:first-child {
        background: #705217;
        padding: 0;
        width: 20px;
        p {
          font-size: 9px;
          width: 85.5px;
          text-align: center;
          height: 10px;
          transform: rotate(-90deg);
        }
      }
    }
  }
`;

export const Persona = styled.section`
  margin-bottom: 150px;
  .gray-holder {
    width: 550.12px;
    ${FlexEnd};
    gap: 28.5px;
  }
  p,
  li {
    font-size: 7.5px;
    line-height: 10px;
  }
  .box-con {
    display: flex;
    width: 100%;
    justify-content: space-between;
    .box {
      width: 260.25px;
      height: 130.88px;
      color: #402e0b;
      padding: 11.25px 18.75px;
      background: rgba(205, 197, 192, 1);
      h3 {
        text-transform: uppercase;
        letter-spacing: -0.02em;
        margin-bottom: 8.5px;
      }
      ul {
        width: 230px;
      }
    }
    .box:nth-child(2) {
      background: rgba(230, 226, 223, 1);
    }
  }

  .gray-box {
    height: 130.88px;
    background: #836f61;
    display: flex;
    width: 100%;
    img {
      width: 209.25px;
      height: 193.5px;
      margin-top: -62px;
    }
    .gray-text {
      width: 258.75px;
      margin-top: 19.12px;
      ${FlexEnd};
      align-items: flex-start;
      gap: 23.25px;
      .gray-flex {
        width: 168px;
        display: flex;
        justify-content: space-between;
        .res {
          ${FlexEnd};
          align-items: flex-start;
          gap: 5.25px;
          h6 {
            font-weight: 600;
            font-size: 10.5px;
          }
          p {
            font-weight: 400;
          }
        }
      }
    }
  }
`;

export const StoryBoard = styled.section`
  margin-bottom: 150px;
  img {
    width: 385.88px;
    height: 288.75px;
    margin-top: 3px;
  }
`;

export const UserFlow = styled.section`
  margin-bottom: 150px;
  h3 {
    font-weight: 400 !important;
    font-size: 13.5px !important;
    margin-top: -5px;
  }
  .flow-flex {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    gap: 50px;
    img {
      width: 386.63px;
      height: 360.51px;
      margin-top: -70px;
    }
    ul {
      color: #46320d;
      width: 182.25px;
      height: 225px;

      li {
        font-weight: 500;
        font-size: 11.25px;
        margin-bottom: 10px;
      }
    }
  }
`;

export const Wireframe = styled.section`
  margin-bottom: 150px;
  h3 {
    font-weight: 400 !important;
    font-size: 13.5px !important;
    margin-top: -5px;
  }
  .low-box {
    display: flex;
    margin-top: 30px;
    gap: 20px;
    img {
      width: 340.82px;
      height: 291.12px;
      margin-top: -10px;
    }
    p {
      width: 148.5px;
      font-weight: 500;
      font-size: 7.5px;
      line-height: 10px;
      color: #46320d;
    }
  }
`;

export const ThankYou = styled.div`
  height: 100vh;
  ${flexColumn};
  gap: 40px;
  img {
    width: 98.02px;
    height: 97.97px;
  }
`;
